module.exports = __webpack_public_path__ + "img/2.57627441.jpg";